
/**
 * 로그인 오류 코드와 안내 문구를 정의한다.
 * @version 1.0.0
 * @created 2026-02-04
 */

/** OAuth 오류 코드. */
export enum OAUTH_ERROR_CODES {
  DB_SAVE_USER = "Database error saving new user",
  DB_GRANT_USER = "500: Database error granting user",
}

/** 미들웨어 인증 오류 문구. */
export enum MIDDLEWARE_ERRORS {
  SESSION_EXPIRED = "세션이 만료되었습니다.",
  INVALID_SESSION = "유효하지 않은 로그인 정보입니다.",
  ACCOUNT_INACTIVE = "비활성화된 계정입니다. 관리자에게 문의하세요.",
  SERVER_ERROR = "서버 오류가 발생했습니다.",
}

/** 오류별 안내 문구. */
export const ERROR_MESSAGE_MAP: Record<string, string> = {
  // Preserve middleware messages.
  [MIDDLEWARE_ERRORS.SESSION_EXPIRED]: MIDDLEWARE_ERRORS.SESSION_EXPIRED,
  [MIDDLEWARE_ERRORS.INVALID_SESSION]: MIDDLEWARE_ERRORS.INVALID_SESSION,
  [MIDDLEWARE_ERRORS.ACCOUNT_INACTIVE]: MIDDLEWARE_ERRORS.ACCOUNT_INACTIVE,
  [MIDDLEWARE_ERRORS.SERVER_ERROR]: MIDDLEWARE_ERRORS.SERVER_ERROR,

  // Translate OAuth errors.
  [OAUTH_ERROR_CODES.DB_SAVE_USER]: "허용되지 않은 이메일입니다.",
  [OAUTH_ERROR_CODES.DB_GRANT_USER]: "비활성화된 계정입니다.",
};

/** 알 수 없는 오류의 안내 문구. */
export const DEFAULT_ERROR_MESSAGE = "알 수 없는 오류가 발생했습니다.";
